import {
  GETVOUCHERTRANSACTIONLIST_SUCCESS,
  GETVOUCHERTRANSACTIONLIST_FAILED,
  RESET_GETVOUCHERTRANSACTIONLIST,
  LOADING_GETVOUCHERTRANSACTIONLIST,
  NETWORK_ERROR_GETVOUCHERTRANSACTIONLIST,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_GETVOUCHERTRANSACTIONLIST:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case GETVOUCHERTRANSACTIONLIST_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case GETVOUCHERTRANSACTIONLIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_GETVOUCHERTRANSACTIONLIST:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_GETVOUCHERTRANSACTIONLIST:
      return (state = initialState);
    default:
      return state;
  }
};
